// extracted by mini-css-extract-plugin
export default {"userManagementHeader":"UserManagement_userManagementHeader__5kkNK","searchFilter":"UserManagement_searchFilter__e9ZH6"};